/**
 * Created by RSchweber-Koren on 3/27/2017.
 */

class TrackingCalendarDataOperationError extends Error {
    constructor({currentOperation, errorMessage, errorData}) {
        super(errorMessage);
        this.name = "TrackingCalendarDataOperationError";
        this.operationName = currentOperation;
        this.errorData = errorData;
    }
}

export default TrackingCalendarDataOperationError;


//////////////////
// WEBPACK FOOTER
// ./src/models/errors/TrackingCalendarDataOperationError.js
// module id = LQOP
// module chunks = 1